import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Alert, AlertsService, AlertType } from 'src/app/providers/services/alerts.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    animations: [
        trigger('newAlertAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(100%)' }),
                animate('0.4s ease-out', style({ opacity: 1, transform: 'none' }))
            ]),
            transition(':leave', [
                style({ opacity: 1, transform: 'none' }),
                animate('0.4s ease-in', style({ opacity: 0, transform: 'translateX(100%)' }))
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertComponent {

  @Input() alert: Alert;

  constructor(
    private alertsService: AlertsService
  ) { }

  removeAlert() {
    this.alertsService.removeAlert(this.alert);
  }

  alertClass(): string {
    switch (this.alert.type) {
      case AlertType.Success:
        return 'alert-success';
      case AlertType.Error:
        return 'alert-error';
      case AlertType.Info:
        return 'alert-info';
      case AlertType.Warning:
        return 'alert-warning';
      default:
        return 'alert-info';
    }
  }

  alertIcon(alert: Alert): string {
    switch (alert.type) {
      case AlertType.Success:
        return 'heroCheckCircle';
      case AlertType.Error:
        return 'heroExclamationTriangle';
      case AlertType.Info:
        return 'heroInformationCircle';
      case AlertType.Warning:
        return 'heroExclamationTriangle';
      default:
        return 'heroInformationCircle';
    }
  }

}
